/*eslint no-use-before-define: off */
import {ACTION_REMOVE_FROM, ACTION_SET, baseReducer} from '@mapsight/core/lib/base/reducer';

import {FeatureSelectionsController} from '@mapsight/core/lib/feature-selections/controller';
import {FEATURE_SELECTION_PRESELECT, FEATURE_SELECTION_SELECT} from '@mapsight/ui/src/js/config/feature/selections';
import {FEATURE_LIST, FEATURE_SOURCES} from '@mapsight/ui/src/js/config/constants/controllers';

import {history} from '../renderer/browser-router';
import {navPosition} from '../routing/nav-pos';

import {ACTION_SET_FROM_ROUTE, ACTION_SET_VIA_HISTORY} from './actions';
import {FEATURE_SELECTION_LAST_ON_TOUR, findFeatureSourceIdForFeatureId} from './selectors';


let _magic = null;

// we can't call history.push imedeatly as is will start a new redux cycle via route-to-store
// so we use setTimeout to put it on hold till the reducer are finished
// (as js has a single threaded execution model, a timeout of 1ms will wait till the current execution path is finished)
let _timeoutHandler = null;
function queueHistory(url, state, debug) {
	clearTimeout(_timeoutHandler);
	_timeoutHandler = setTimeout(
		() => {
			// console.log('NavposSelectionController setting history',{url, state, debug});
			history.push(url, state);
		},
		1
	);
}

function reduceDeselectAllFeatureSelect(state, action, globalState) {
	const navPos = navPosition(_magic, history.location?.pathname, history.location?.state);

	console.log('navpos-selection-controller reduceDeselectAllFeatureSelect', {
		action,
		navPos,
		removeDeepLink: (navPos.deepLink || navPos.select)
	});

	if (navPos.deepLink || navPos.select || navPos.list || navPos.listMorePoi) {
		// deepLink entfernen, route-to-store ruft dann auch deselectAll auf
		queueHistory(
			`${navPos.app ? navPos.app.url + (navPos.app.lang === 'en' ? '/map' : '/karte') : ''}`,
			{},
		);
	} else {
		state = baseReducer(state, action);
	}
	return state;
}

function reduceSelectExclFeatureSelect(state, action, globalState) {
	const navPos = navPosition(_magic, history.location?.pathname, history.location?.state);
	const featureSourceInfo = featureSourceInfoForId(globalState, action.value.length ? action.value[0] : action.value);

	if (
		// keine deeplinks erlaubt
		!navPos.app
	) {
		console.warn('navpos-selection-controller reduceSelectExclFeatureSelect: select without app. this should not happen in Stade!');
		// wenn keine deepLinks erlaubt, das select in den url-state packen, damit es Teil der Browser-History wird
		queueHistory(
			'/',
			{select: action.value},
		);
	} else {
		console.log('navpos-selection-controller reduceSelectExclFeatureSelect', {
			action,
			navPos,
			removeDeepLink: (navPos.deepLink || navPos.select)
		});
		queueHistory(
			`${navPos.app.url}/${featureSourceInfo.featureId}`,
			{},
		);
	}
	return state;
}

function reduceLikePreselectionController(state, action, globalState) {
	state = baseReducer(state, {...action, type: ACTION_SET});

	if (action.path.length === 2 && action.path[0] === FEATURE_SELECTION_SELECT &&
		(
			(Array.isArray(action.value) && action.value.length > 0) ||
			(action.value && !Array.isArray(action.value))
		)
	) {
		state = baseReducer(state, {...action, type: ACTION_SET, path: [FEATURE_SELECTION_PRESELECT, action.path[1]]});

		const id = Array.isArray(action.value) ? action.value[0] : action.value;
		const navPos = navPosition(_magic, history.location?.pathname, history.location?.state);
		if(navPos.app && globalState[FEATURE_SOURCES][navPos.app.uri].ids && globalState[FEATURE_SOURCES][navPos.app.uri].ids.includes(id)) {
			// console.log('remembering last on tour', {id, app: navPos.app});
			state = baseReducer(state, {
				...action,
				type: ACTION_SET,
				path: [FEATURE_SELECTION_LAST_ON_TOUR, action.path[1]]
			});
		}
	}
	return state;
}

const featureSourceInfoForId = (state, featureId) => {
	const featureSources = state[FEATURE_SOURCES];
	const listSourceId = state[FEATURE_LIST].featureSource;

	// prefer list feature source
	const source = featureSources[listSourceId] && findFeatureSourceIdForFeatureId({[listSourceId]: featureSources[listSourceId]}, featureId) ?
		listSourceId :
		findFeatureSourceIdForFeatureId(featureSources, featureId);

	return {
		source,
		listSource: listSourceId,
		featureId,
		foreign: listSourceId !== source,
	};
};

export class NavposSelectionController extends FeatureSelectionsController {
	constructor(controllerName, magic) {
		super(controllerName);
		NavposSelectionController.setMagic(magic);
	}

	static setMagic(magic) {
		_magic = magic;
	}

	reduce(state = {}, action, globalState) {
		const isSelectionSelect = (action.path?.length === 2 && action.path[0] === FEATURE_SELECTION_SELECT);
		const deselectAll = (isSelectionSelect &&
			(
				(action.type === ACTION_SET_VIA_HISTORY && Array.isArray(action.value) && action.value.length === 0) ||
				(action.type === ACTION_SET && Array.isArray(action.value) && action.value.length === 0) ||
				(action.type === ACTION_REMOVE_FROM && ((baseReducer(state, action))[FEATURE_SELECTION_SELECT][action.path[1]].length) === 0)
			)
		);
		const selectExcl = (
			(action.type === ACTION_SET || action.type === ACTION_SET_VIA_HISTORY) &&
			isSelectionSelect &&
			(
				(Array.isArray(action.value) && action.value.length > 0) ||
				(action.value && !Array.isArray(action.value))
			)
		);

		console.log('navpos-selection-controller', {
			action,
			isSelectionSelect,
			deselectAll,
			selectExcl,
			baseReducer: baseReducer(state, action),
		});

		// console.log('NavposSelectionController', {...action, globalState, deselectAll, selectExcl, isSelectionSelect});
		if (history && deselectAll) {
			console.warn('navpos-selection-controller recognized deselectAll which should be disabled by design for Stade!');
			return reduceDeselectAllFeatureSelect(state, action, globalState);
		} else if (history && selectExcl) {
			return reduceSelectExclFeatureSelect(state, action, globalState);
		} else if (action.type === ACTION_SET_FROM_ROUTE || (!history && (selectExcl || deselectAll))) {
			return reduceLikePreselectionController(state, action, globalState);
		} else if (action.type === ACTION_SET_VIA_HISTORY) {
			// ACTION_SET_VIA_HISTORY for use case we're not interested here
			return baseReducer(state, {...action, type: ACTION_SET});
		}
		return baseReducer(state, action);
	}
}
